import React from "react";

import { ProviderWrapper } from "./src/components/ProviderWrapper";
export const wrapRootElement = ({ element }) => (
  <ProviderWrapper>{element}</ProviderWrapper>
);
